module.exports = __webpack_public_path__ + "static/media/footer.5fba86c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/MobileApp/assets/footer.png
// module id = 549
// module chunks = 0